/**
 * Maps checklist template / UI rows to compliance section_detail keys
 * for tooltip popovers (extracted data, findings, sources).
 */

const CRITERIA_SECTION_KEYS = ['evaluation', 'eligibility'];

/** Eligibility checklist template section id → compliance section keys. */
export function complianceKeysForEligibilitySection(sectionId) {
  if (!sectionId) return [];
  if (sectionId === 'timeline') return ['identity_timeline'];
  if (sectionId === 'pre_meeting') {
    return ['iep_compliance', 'eligibility_compliance', 'evaluation', 'eligibility'];
  }
  if (sectionId === 'post_meeting') {
    return ['iep_compliance', 'eligibility_compliance', 'eligibility'];
  }
  if (String(sectionId).endsWith('_criteria')) return [...CRITERIA_SECTION_KEYS];
  return [];
}

/** True when section_details may include evaluation / assessment extracted data. */
export function sectionHasAssessmentTooltip(sectionKeys) {
  const keys = Array.isArray(sectionKeys) ? sectionKeys : [sectionKeys];
  return keys.some((k) => k === 'evaluation' || k === 'eligibility');
}
